import AxiosInstance from "./api";

export const JournalVoucher5Service = {
  create: (payload) => AxiosInstance.post("/private/journal-voucher-5", payload),
  update: (id, payload) => AxiosInstance.put(`/private/journal-voucher-5/${id}`, payload),
  delete: (id) => AxiosInstance.delete(`/private/journal-voucher-5/${id}`),
  findAll: (params) => AxiosInstance.get("/private/journal-voucher-5", { params }),
  findById: (id) => AxiosInstance.get(`/private/journal-voucher-5/${id}`),
  preview: (params) => AxiosInstance.get("/private/journal-voucher-5/sync/preview", { params }),
  sync: (params) => AxiosInstance.post("/private/journal-voucher-5/sync", null, { params }),
  getAccounts: (params) => AxiosInstance.get("/private/journal-voucher-5/accounts", { params }),
};
